import * as _ from 'underscore';

import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { IDataSourceInfo } from '../../../../ts/models/IDataSourceInfo';
import { Set } from '../../../../ts/models/Set';
import { ChangeExtractDsToLiveAction as ChangeExtractDsToLiveActionService} from '../../../../extract/services/ChangeExtractDsToLiveAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { ChangeExtractDsToLiveAction } from '../../../actions/spaces/ChangeExtractDsToLiveAction';
import { reloadSpace } from '../content/RefreshContentSagas';

export function* handleChangeExtractDsToLiveAction(action: ChangeExtractDsToLiveAction) {

  try {
    yield call(openChangeExtractDsToLiveWindow,  action.datasources);
    yield call(reloadSpace); // force to reload the page after change extract to live
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openChangeExtractDsToLiveWindow(datasources: IDataSourceInfo[]) {
  const filteredDs: IDataSourceInfo[] = datasources.filter(ds =>
    ds.hasExtracts && !ds.isExtractOnly && !ds.isFileBased && ds.connectionType !== 'sqlproxy');
  if(filteredDs.length < 1) {
    return;
  }
  return ChangeExtractDsToLiveActionService.execute(Set.fromIdItemArray(filteredDs));
}
